import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Blog_side_bar from '../components/BlogSideBar';
import Popular_blogs from '../components/PopularBlogs';

const Blog_Details = () => {
  const { blogSlug } = useParams(); // Get the blog slug from the URL
  const [blogData, setBlogData] = useState(null); // State to hold blog details
  const [loading, setLoading] = useState(true); // State for loading
  const [error, setError] = useState(null); // State for errors

  // Fetch blog details using the API
  useEffect(() => {
    const fetchBlogDetails = async () => {
      try {
        setLoading(true); // Start loading
        const apiEndpoint = `https://blogs.vananiassociates.com/api/blogs/detail/${blogSlug}`;
        const response = await fetch(apiEndpoint);

        if (!response.ok) {
          throw new Error('Failed to fetch blog details');
        }

        const data = await response.json();
        setBlogData(data); // Store the blog data in state
      } catch (err) {
        setError(err.message); // Handle errors
      } finally {
        setLoading(false); // End loading
      }
    };

    fetchBlogDetails();
  }, [blogSlug]);

  // Show loading, error, or content
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!blogData) return <p>No data found for this blog.</p>;

  return (
    <div className="container-fluid mt-5 mb-5 px-5 blog_center_wrap">
      <div className='row justify-content-center px-2'>
        <div className='col-md-9 blog_center_wrap'>
          <div className="blog_details_wrap">
            <div className="img_wrap">
              <img
                className="img_width rounded-2"
                src={blogData.banner || 'https://via.placeholder.com/800'}
                alt={blogData.title || 'Blog Image'}
              />
            </div>
            <h1 className="blog_main_title">{blogData.title || 'Blog Title'}</h1>
            <div className="social_wrap text-center mt-4 mb-4">
              <ul className="d-flex m-0 p-0 list-unstyled justify-content-center">
                <p className="mb-0">Share:</p>
                <li><a href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`} target="_blank" rel="noopener noreferrer">FACEBOOK</a></li>
                <li><a href={`https://twitter.com/intent/tweet?url=${window.location.href}`} target="_blank" rel="noopener noreferrer">TWITTER</a></li>
                <li><a href={`https://pinterest.com/pin/create/button/?url=${window.location.href}`} target="_blank" rel="noopener noreferrer">PINTEREST</a></li>
              </ul>
            </div>
            <div dangerouslySetInnerHTML={{ __html: blogData.content || '' }}></div>
          </div>
        </div>
        <div className='col-md-3 right_bar sticky top-28 self-start'>
          <Popular_blogs />
        </div>
      </div>
    </div>
  );
};

export default Blog_Details;
